import React from 'react';
import { useSelector } from 'react-redux';
import Helmet from 'react-helmet';
import {
  shape, string, arrayOf, func,
} from 'prop-types';
import { getMetricsUrl } from '../selectors';

export default function HelmetConfig({
  titleTemplate,
  defaultTitle,
  locale,
  routes,
  preLoadLinks,
  bodyAttributes,
  styleHref,
  colorTheme,
}) {
  const metricsUrl = useSelector(getMetricsUrl);
  const currentRoute = routes && routes.length > 0 && routes[routes.length - 1];
  const routeTitle = (currentRoute?.getTitle && currentRoute.getTitle()) || currentRoute?.title;

  return (
    <Helmet
      htmlAttributes={{
        lang: locale,
        'data-dls-mode': colorTheme,
        'data-dls-surface': 'base',
      }}
      titleTemplate={titleTemplate}
      defaultTitle={defaultTitle}
      title={routeTitle}
      bodyAttributes={{ class: bodyAttributes }}
      link={[
        {
          rel: 'icon',
          href: 'https://www.aexp-static.com/cdaas/one/statics/@americanexpress/static-assets/2.28.0/package/dist/img/logos/dls-logo-bluebox-alt.svg',
        },
        {
          rel: 'stylesheet',
          href: styleHref,
        },
        ...preLoadLinks,
      ]}
      meta={[
        { 'http-equiv': 'X-UA-Compatible', content: 'IE=edge' },
        { charset: 'utf-8' },
        {
          name: 'viewport',
          content: 'width=device-width, initial-scale=1',
        },
        {
          name: 'application-name',
          content: 'American Express - Manage Your Account',
        },
        { name: 'theme-color', content: '#006FCF' },
        { name: 'apple-mobile-web-app-capable', content: 'false' },
      ]}
      // eslint-disable-next-line react/jsx-props-no-spreading -- conditionally spread props
      {...metricsUrl && { script: [{ src: metricsUrl }] }}
    />
  );
}

HelmetConfig.propTypes = {
  locale: string.isRequired,
  titleTemplate: shape({}).isRequired,
  defaultTitle: string.isRequired,
  routeTitle: string.isRequired,
  bodyAttributes: shape({}).isRequired,
  styleHref: string.isRequired,
  preLoadLinks: shape({}).isRequired,
  colorTheme: string.isRequired,
  location: shape({
    query: shape({
      ismobile: string,
      vortex: string,
    }),
    pathname: string,
  }).isRequired,
  routes: arrayOf(
    shape({
      title: string,
      getTitle: func,
    })
  ).isRequired,
};
